export default {"src":"/login-app/[GIT_HASH]/_next/static/media/pagerduty_color.a572c3e6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};